import { styled } from '@mui/material/styles';

interface ImageCoverProps {
    src: string | null;
}

export default function ImageCover({ src }: ImageCoverProps) {
    if (!src) {
        return null;
    }
  
    return (
        <Root>
            <img src={ src }
                alt="Hero"
                loading="lazy" />
        </Root>
    );
}

const Root = styled('div')(({ theme }) => ({
    flex: 1,
    maxWidth: theme.breakpoints.values.sm,
    overflow: 'hidden',
    img: {
        objectFit: 'cover',
        width: '100%',
        height: '100%'
    },
    [theme.breakpoints.down('sm')]: {
        maxHeight: '30vh'
    }
}));
